import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Image } from 'semantic-ui-react';
import styles from './DesktopHeader.styles';
import searchIcon from '../../../../assets/images/icon-search.svg';

const SignedOutSubMenu = ({ login }) =>
  (<Menu.Menu position="right">
    <Menu.Item
      name="signIn"
      link
      active={null /* activeItem === 'signIn'*/}
      onClick={login}
      style={styles.menuItem}
      className={''/* "greenHighlightedMenuButton"*/}
    >
      {'SIGN IN'}
    </Menu.Item>
    <span style={styles.separator} />
    <Menu.Item
      name="help"
      link
      active={null /* activeItem === 'help'*/}
      onClick={null /* this.handleItemClick*/}
      href="https://www.thehuddle.com/story/sports/fantasy/football/2025/05/12/help-with-the-huddle-site/83556253007/"
      style={styles.menuItem}
      className={''/* "greenHighlightedMenuButton"*/}
    >
      HELP
    </Menu.Item>
    {/*<Menu.Item link>
      <Image
        src={searchIcon}
        className={null}
        style={styles.icon}
        as="a"
        href="#"
        target="_blank"
      />
    </Menu.Item>*/}
  </Menu.Menu>);

SignedOutSubMenu.propTypes = {
  login: PropTypes.func.isRequired,
};

export default SignedOutSubMenu;



// WEBPACK FOOTER //
// ./src/app/components/Header/DesktopHeader/SignedOutSubMenu.js